<template>
    <div class="md-layout">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <index-table id="organization-index-table" endpoint="organizationsIndex" title="Organizations" icon="">
                <template slot="head">
                    <index-table-head slug="name">{{ $t('Name') }}</index-table-head>
                    <index-table-head slug="reseller">{{ $t('Reseller') }}</index-table-head>
                    <index-table-head slug="compliance_active" class="text-center">{{ $t('Compliance active') }}</index-table-head>
                    <index-table-head slug="dfs_active" class="text-center">{{ $t('DFS active') }}</index-table-head>
                    <index-table-head slug="academy_active" class="text-center">{{ $t('Academy active') }}</index-table-head>
                    <index-table-head slug="created_at">{{ $t('Created') }}</index-table-head>
                    <index-table-head slug="actions" :sortable="false" class="text-center"></index-table-head>
                </template>
              <md-table-row class="search">
                <index-table-filter-text slug="name"></index-table-filter-text>
                <index-table-filter-text slug="reseller"></index-table-filter-text>
                  <index-table-filter-triple-state slug="compliance_active"></index-table-filter-triple-state>
                  <index-table-filter-triple-state slug="dfs_active"></index-table-filter-triple-state>
                  <index-table-filter-triple-state slug="academy_active"></index-table-filter-triple-state>
                  <index-table-filter-date slug="created_at"></index-table-filter-date>
                  <md-table-cell></md-table-cell>
              </md-table-row>
                <organizations-row v-for="(item, key) in items" :key="key" :item="item"/>

            </index-table>
        </div>
    </div>
</template>

<style>
.search .md-table-cell{
  padding: 0 12px;
  border-top: none;
}
</style>


<script>
    import {mapGetters, mapMutations} from "vuex";
    import IndexTable from "../../components/Index/IndexTable";
    import IndexTableHead from "../../components/Index/IndexTableHead";
    import OrganizationsRow from "./OrganizationsRow";
    import IndexTableFilterText from "@/new/components/Index/IndexTableFilterText";
    import IndexTableFilterDate from "@/new/components/Index/IndexTableFilterDate";
    import IndexTableFilterTripleState from "@/new/components/Index/IndexTableFilterTripleState";

    export default {
        name: "Organizations",
        components: {
            IndexTableFilterTripleState,
            OrganizationsRow, IndexTableHead, IndexTable, IndexTableFilterText, IndexTableFilterDate},
        computed: {
            ...mapGetters('indexTable', {
                items: 'getItems',
            }),
        },
        data() {
            return {
            }
        },
        methods: {
            ...mapMutations('app', {
                setTitlePage: 'setTitlePage',
            })
        },
        mounted() {
            this.setTitlePage(this.$t('Organizations'));
        }
    }
</script>